import axios, { AxiosInstance } from 'axios';

import { IConfig, AXIOS_DEFAULT_CONFIG } from '../common';
import {
  GetBlockchainsByAddressApiArg,
  GetBlockchainsByAddressApiResponse,
} from './types';

export class StatusBlockchainsGateway {
  public api: AxiosInstance;

  constructor(private readonly config: IConfig) {
    this.api = axios.create({
      ...config,
      ...AXIOS_DEFAULT_CONFIG,
      baseURL: config.statusBlockchainsUrl,
    });
  }

  public async getBlockchainsByAddress({
    address,
    period,
  }: GetBlockchainsByAddressApiArg): Promise<GetBlockchainsByAddressApiResponse> {
    const { data } = await this.api.get<GetBlockchainsByAddressApiResponse>(
      `/api/v1/blockchains/by-address/${address}?period=${period}`,
    );

    return data;
  }
}
